import React from 'react';

import AboutComponent from '../components/app/About/About.jsx';

const About = (props) => {
  return (
    <AboutComponent {...props}/>
  );
};

export default About;
